import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,_vm._b({staticClass:"w-list",attrs:{"dense":""}},'VList',{ ..._vm.$props, ..._vm.$attrs },false),[_vm._t("default"),_c(VListItemGroup,[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }